import { ES_DESARROLLO } from './entorno';

// URLs de las plataformas. Se pueden cambiar con variables REACT_APP_ (en local, en
// .env.development.local); sin ellas quedan las de este ambiente (dev).
export const BACKEND = process.env.REACT_APP_BACKEND || 'https://dev-api-activos.cydocs.cl';
export const PORTAFOLIO = process.env.REACT_APP_PORTAFOLIO || 'https://test-api-portafolio.cydocs.cl';
export const ADMINISTRACION_USUARIOS = process.env.REACT_APP_ADMINISTRACION_USUARIOS || 'https://test-api-usuarios.cydocs.cl';
export const BACKEND_SDA = process.env.REACT_APP_BACKEND_SDA || 'https://test-api-sda.cydocs.cl/v1';
export const BACKEND_GP = process.env.REACT_APP_BACKEND_GP || 'https://test-api-gestor-pagos.cydocs.cl';
export const FRONTEND = process.env.REACT_APP_FRONTEND || 'https://dev-activos.cydocs.cl';
export const LOGIN = process.env.REACT_APP_LOGIN || 'https://dev-account.cydocs.cl';
export const REDIRECT_BASE = process.env.REACT_APP_REDIRECT_BASE || 'https://test-api-usuarios.cydocs.cl/login';
export const URL_MESA_AYUDA_CYD = process.env.REACT_APP_URL_MESA_AYUDA_CYD || 'https://soportecyd.sd.cloud.invgate.net/';
export const SENDMAIL = process.env.REACT_APP_SENDMAIL || 'https://sendmail.cydingenieria.com';
export const STORAGE = process.env.REACT_APP_STORAGE || 'https://storage.cydingenieria.com';
export const API_PERMISOS = process.env.REACT_APP_API_PERMISOS || 'https://dev-api-gestor-permisos.cydocs.cl';

if (ES_DESARROLLO) {
  // En `npm start` el backend tiene que ser explícito: sin REACT_APP_BACKEND, toda la
  // aplicación leería y escribiría en el backend de producción.
  if (!process.env.REACT_APP_BACKEND) {
    throw new Error(
      '[development] Define REACT_APP_BACKEND en .env.development.local (por ejemplo http://localhost:3002). ' +
        'Para apuntar a producción a propósito, escribe su URL explícitamente.',
    );
  }
  console.info('[development] URLs en uso:', {
    BACKEND,
    BACKEND_SDA,
    BACKEND_GP,
    PORTAFOLIO,
    ADMINISTRACION_USUARIOS,
    API_PERMISOS,
    LOGIN,
    STORAGE,
    SENDMAIL,
  });
}
